import SensorsOffOutlinedIcon from "@mui/icons-material/SensorsOffOutlined";
import connectivityAlertServices from "app/services/automations/connectivity-alert-services";
import ConnectivityAlertEditor from "./ConnectivityAlertEditor";
import {
    ConnectivityAlertCardDetails,
    ConnectivityAlertCardSummary,
    connectivityAlertStatusChip,
    connectivityAlertSubtitle,
} from "./ConnectivityAlertSummary";

// «Conexión de equipos» (ConnectivityAlert en el backend).
const connectivityAlertType = {
    key: "connectivity_alert",
    label: "Conexión de equipos",
    pickerTitle: "Avisar si un sensor o un local deja de enviar datos",
    pickerDescription: "Un aviso cuando un local pierde la conexión (su gateway o su equipo de IA) o un sensor se calla, con su último valor y su batería. Los equipos nuevos quedan incluidos solos.",
    icon: SensorsOffOutlinedIcon,
    order: 40,
    Editor: ConnectivityAlertEditor,
    CardSummary: ConnectivityAlertCardSummary,
    CardDetails: ConnectivityAlertCardDetails,
    subtitle: connectivityAlertSubtitle,
    statusChip: connectivityAlertStatusChip,
    setEnabled: (item, enabled) => connectivityAlertServices.updateConnectivityAlert(item.id, { enabled }),
    remove: (item) => connectivityAlertServices.deleteConnectivityAlert(item.id),
    confirmRemove: (item) => `¿Eliminar "${item.name}"? Dejarás de recibir avisos cuando un equipo o un local deje de enviar datos.`,
    canDuplicate: true,
    draftTypes: [],
    draftTarget: () => null,
};

export default connectivityAlertType;
